import React, { useState } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import CustomDatePicker from "./Custom-Datepicker";
import CustomDatepickerMonthYear from "./Custom-DatepickerMonthYear";
import { FaSpinner } from "react-icons/fa";

const Dynamic_FilterForm = ({
  formData,
  handleChange,
  handleGetData,
  handleReset,
  filterFormData,
}) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const handleAction = async (e, action, setLoading) => {
    e.stopPropagation();
    const toggleBtn =
      e.currentTarget?.closest(".btn-group, .dropdown")?.querySelector('[data-bs-toggle="dropdown"]') ||
      document.getElementById("excel-btn");
    setLoading(true);
    try {
      if (action) await action();
      toggleBtn?.click();
    } finally {
      setLoading(false);
    }
  };

  const customStyle = {
    control: (provided) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };

  return (
    <div
      className="dropdown-menu custom-dropdown-width"
      aria-labelledby="excel-btn"
    >
      <div className="container">
        <div className="row">
          <form onClick={stopPropagation}>
            <div className="row">
              {formData.map((ele, index) => (
                <div className="col-md-4 mt-1" key={index}>
                  <Form.Group>
                    {ele?.type !== "Checkbox" && (
                      <Form.Label className="mb-0">{ele?.name}</Form.Label>
                    )}
                    {ele?.type === "Select" ? (
                      <Select
                        options={[...ele?.options]}
                        value={
                          ele?.options?.find(
                            (option) =>
                              option.value ===
                              filterFormData?.find(
                                (item) => item.label === ele?.name
                              )?.value
                          ) || null
                        }
                        name={ele?.name}
                        placeholder={ele?.placeholderText || ele?.name}
                        onChange={(e) => handleChange(e, ele?.name)}
                      />
                    ) : ele?.type === "Date" ? (
                      <CustomDatePicker
                        handleChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                        showYearDropdown
                        dropdownMode="select"
                        name={ele?.name}
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                        value={
                          filterFormData?.find((o) => o.label === ele?.name)
                            ?.value || null
                        }
                      />
                    ) : ele?.type === "DateMonthYear" ? (
                      <CustomDatepickerMonthYear
                        handleChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                        showYearDropdown
                        dropdownMode="select"
                        name={ele?.name}
                        className="form-control"
                        placeholderText="Month,Year"
                        value={
                          filterFormData?.find((o) => o.label === ele?.name)
                            ?.value || null
                        }
                      />
                    ) : ele?.type === "Text" ? (
                      <Form.Control
                        type="text"
                        name={ele?.name}
                        onChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                      />
                    ) : ele?.type === "Number" ? (
                      <Form.Control
                        type="number"
                        name={ele?.name}
                        onChange={(e) =>
                          handleChange(e.target.value, ele?.name)
                        }
                      />
                    ) : ele?.type === "IsMulti" ? (
                      <Select
                        options={[...ele?.options]}
                        value={ele?.options?.filter((option) =>
                          filterFormData
                            ?.find((item) => item.label === ele?.name)
                            ?.value?.includes(option.value)
                        )}
                        name={ele?.name}
                        placeholder={ele?.placeholderText || ele?.name}
                        isMulti
                        onChange={(selectedOptions) =>
                          handleChange(
                            selectedOptions ? selectedOptions.map((option) => option.value) : [],
                            ele?.name
                          )
                        }
                        styles={customStyle}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                      />
                    ) : ele?.type === "Checkbox" ? (
                      <Form.Check
                        type="checkbox"
                        className="mt-4"
                        label={ele?.placeholderText || ele?.name}
                        checked={
                          filterFormData?.find(
                            (item) => item.label === ele?.name
                          )?.value || false
                        }
                        onChange={(e) =>
                          handleChange(e.target.checked, ele?.name)
                        }
                      />
                    ) : null}
                  </Form.Group>
                </div>
              ))}
            </div>
          </form>
<div className="row mt-2">
  <div className="d-flex flex-column justify-content-end  flex-md-row justify-content-md-end gap-2">
    <button
      className="custom-btn"
      onClick={(e) => handleAction(e, handleReset, setResetLoading)}
      disabled={resetLoading || btnLoading}
      type="button"
    >
      {resetLoading ? <FaSpinner className="sm-spinner" /> : "Reset"}
    </button>

    <button
      className="custom-btn"
      onClick={(e) => handleAction(e, handleGetData, setBtnLoading)}
      disabled={resetLoading || btnLoading}
      type="button"
    >
      {btnLoading ? <FaSpinner className="sm-spinner" /> : "Get data"}
    </button>
  </div>
</div>
        </div>
      </div>
    </div>
  );
};

export default Dynamic_FilterForm;
